import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import InfoTip from './InfoTip';

export default function DevConsoleLayout({ title, subtitle, actions, children }) {
  return (
    <div className="min-h-screen bg-[#08101c] text-slate-100">
      <div className="border-b border-white/10 bg-[#0b1524]/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 md:flex-row md:items-end md:justify-between md:px-6">
          <div className="space-y-1">
            <div className="text-xs uppercase tracking-[0.35em] text-cyan-300/80">Developer Console</div>
            <div className="flex items-center gap-1">
              <h1 className="font-serif text-3xl font-semibold text-white">{title}</h1>
              <InfoTip content={subtitle} label={`About ${title}`} className="text-slate-300 hover:bg-white/10 hover:text-white" />
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            {actions}
            <Link to="/dashboard">
              <Button variant="outline" className="border-white/15 bg-white/5 text-white hover:bg-white/10">
                Back to App
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 py-6 md:px-6">
        {children}
      </div>
    </div>
  );
}
